// extracted by mini-css-extract-plugin
module.exports = {"container":"GkbHs","option":"F6O9o","item":"jEbHo","name":"lyUS2","desc":"ki5++","price":"sN4J7"};